import React, { useContext } from 'react';
import { EventContext } from '../../Service/Context/EventContext';
import { KindSelectProxy } from '../../Molecules/Event/KindSelect';
import EventDates from '../../Molecules/Event/EventDates';
import { LeadOriginSelectProxy } from '../../Molecules/Event/LeadOriginSelect';
import PanePaper from '../../Molecules/PanePaper';
import EventKindSelect from '../../Molecules/Event/EventKindSelect';
import { Space } from '@mantine/core';
import BookitupTutorialIcon from "../../Atoms/BookitupTutorialIcon";

const DatePane = () => {
  const { event, handleChange, saveEvent } = useContext(EventContext);
  const { dates, kind } = event;

  return (
    <div>
      <PartialEventData
        recommendationId={event.recommendationId}
        id={event.id}
        saveValue={(value, name) => {
          saveEvent({ [name]: value });
        }}
        offers={event.offers}
        kind={kind}
        dates={dates}
        changeHandler={handleChange}
      />
    </div>
  );
};

const PartialEventData = React.memo(
  ({ id, dates, changeHandler, saveValue }) => (
    <div style={{ height: '100%' }}>
      {id !== undefined && <input type="hidden" name="id" value={id} />}

      <PanePaper title="common.dateandkind" tooltip="help.event.dates.pane"
                 rightSection={<BookitupTutorialIcon videoUrl={"https://www.youtube.com/watch?v=4WdMhJZo-vo"} name={"EventDetails"} />}>
        <EventDates
          saveValue={(value, name) => {
            saveValue(value, name);
          }}
          dates={dates}
          changeHandler={changeHandler}
        />
        <Space h={5} />
        <EventKindSelect />
        <LeadOriginSelectProxy />
      </PanePaper>
    </div>
  ),
  (prevProps, nextProps) => prevProps.dates === nextProps.dates,
);

export default DatePane;
